import * as React from 'react'
import moment from 'moment';

import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'

export const AutomaticRenewalModal = ({
  close,
  handleUpdateRecurringClick,
  price,
  show,
  subscriptionStatus,
  subscriptionType,
}) => {
  const { modalRef, } = useModalAccessibility(close)
  
  const { last_four, recurring } = subscriptionStatus;
  const expiration = moment(subscriptionStatus.expiration).format('MMMM Do, YYYY');
  const renewDate = moment(subscriptionStatus.expiration).add('days', 1).format('MMMM Do, YYYY');

  React.useEffect(() => {
    if (show) {
      modalRef.current?.showModal();
    } else {
      modalRef.current?.close();
    }
  }, [show]);

  let header = 'Turn on automatic renewal?';
  let body = `By turning on automatic renewal, your subscription to ${subscriptionType} will be renewed on ${renewDate} and your card ending in ${last_four} will be charged $${price}.`;
  let buttonText = 'Turn on';

  if (recurring) {
    header = 'Turn off automatic renewal?';
    body = `By turning off automatic renewal, your subscription to ${subscriptionType} will be canceled at the end of the current billing cycle (${expiration}) and you will be downgraded to Quill Basic.`;
    buttonText = 'Turn off';
  }

  return (
    <dialog
      aria-labelledby="automaticRenewalModalTitle"
      aria-modal="true"
      className="automatic-renewal-modal automatic-renewal-modal-container quill-modal modal-body"
      onCancel={close}
      ref={modalRef}
    >
      <div>
        <h3 className="title" id="automaticRenewalModalTitle">
          {header}
        </h3>
      </div>
      <p>{body}</p>
      <div className="form-buttons">
        <button
          className="quill-button outlined green medium focus-on-light"
          onClick={close}
          type="button"
        >
          Cancel
        </button>
        <button
          className="quill-button contained green medium focus-on-light"
          onClick={handleUpdateRecurringClick}
          type="button"
        >
          {buttonText}
        </button>
      </div>
    </dialog>
  );
};

export default AutomaticRenewalModal;
